import React, {useState} from 'react'
import {useParams} from "react-router";
import Tr from "translations/Translations";
import SimpleSelect from "components/SimpleSelect";
import {makeStyles} from "@material-ui/styles";
import WorkableButton from "components/button/WorkableButton";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import GridBlock from "components/GridBlock";
import Typography from "components/Typography";
import clsx from "clsx";
import PropTypes from "prop-types";
import TitledComponent from "../../../../../../../../../../components/TitledComponent";

const useStyle = makeStyles(theme => ({
    root: {},
    hidden: {
        display: "none"
    },
    select: {
        width: 400,
    },
    menuItemClassName: {
        whiteSpace: 'normal'
    },
    column: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        flexBasis: '100%',
        padding: theme.spacing(2)
    },
    button: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(2),
    }
}))

function OfferEspdInternal(
    {
        offerEdit,
        disabled,
        positionItems,
        visible
    }) {
    const classes = useStyle();
    const params = useParams();
    const [positionId, setPositionId] = useState("");
    const [error, setError] = useState();
    const [working, setWorking] = useState(false);

    const goToEspd = () => {
        if (offerEdit.espdOnPositions && positionId === "") {
            setError(Tr("choose_position"))
            return;
        }
        setWorking(true);
        DemandOffersOfferService.redirectContractorESPDMpAppUrl(params.id, params.stageId, positionId).finally(() => setWorking(false));
    }


    return (
        <GridBlock
            className={clsx({[classes.hidden]: !visible})}
            wrap='nowrap'
            itemClassName={classes.column}
        >
            <div>
                <Typography>{Tr('offer_espd_type_internal_help')}</Typography>
            </div>
            <TitledComponent
                title={Tr("go_to_form")}
            >
                <GridBlock>
                    {
                        offerEdit.espdOnPositions &&
                        <SimpleSelect
                            label={Tr('choose_position')}
                            className={classes.select}
                            menuItemClassName={classes.menuItemClassName}
                            items={positionItems}
                            value={positionId}
                            onChange={(e) => {
                                setError()
                                setPositionId(e.target.value)
                            }}
                            error={error}
                            disabled={disabled || working}
                        />
                    }
                    <WorkableButton className={classes.button} disabled={disabled} working={working} onClick={goToEspd}>{Tr("go")}</WorkableButton>
                </GridBlock>
            </TitledComponent>
        </GridBlock>
    )
}

OfferEspdInternal.propTypes = {
    visible: PropTypes.bool.isRequired
};

export default OfferEspdInternal;